import Link from "next/link";
import { useRouter } from "next/router";
import { useTranslation } from "react-i18next";

import EventHead from "@/my_components/_Events/sections/EventHead";
import EventList from "@/my_components/_Events/sections/Events";

import BlogGridMinimal from "@/my_components/Blogs/Components/BlogGridMinimal";
import Newsletter_2 from "@/my_components/Newsletters/Newsletter_2";
import EventCarouse from "@/my_components/Events/EventCarouse";

// CONFIGS AND ROUTE
import { ROUTE } from "@/route/app_routes.js";



const EventsOnSmartTech = () => {
  const { t } = useTranslation("events");
  const router = useRouter();
  const search = typeof router.query.search === "string" ? router.query.search : "";
  const upcoming = typeof router.query.upcoming === "string" ? router.query.upcoming : "";

  return (
    <>
      <EventHead search={search} upcoming={upcoming} />

      <div className="rbt-section-gap">
        <div className="container">
          <EventList />
        </div>
      </div>

      <div className="rbt-events">
        <div className="container">
          <div className="rbt-sec-head">
            <div>
              <span className="rbt-eyebrow">
                <span className="rbt-eyebrow-dot" aria-hidden="true" />
                {t("onSmartTech.keepExploring", "Keep exploring")}
              </span>
              <h2 className="rbt-sec-head__title rbt-events__title">{t("onSmartTech.moreEvents", "More events")}</h2>
            </div>
          </div>
          <EventCarouse />
        </div>
      </div>

      <div className="rbt-call-to-action-area rbt-section-gap bg-color-secondary-alt">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="rbt-cta-6 text-center">
                <div className="content">
                  <h1 className="title">
                    {t("onSmartTech.cta.title", "Ready to start")}
                    <br /> {t("onSmartTech.cta.titleContinued", "learning for free?")}
                  </h1>
                  <p>{t("onSmartTech.cta.description", "No cost, no catch — just real courses.")}</p>
                  <div className="rbt-button-group justify-content-center">
                    <Link className="rbt-btn btn-gradient" href={ROUTE.register}>
                      {t("onSmartTech.cta.joinButton", "Join for Free")}
                    </Link>
                    <Link className="rbt-btn btn-border" href={ROUTE.course}>
                      {t("onSmartTech.cta.browseButton", "Browse Courses")}
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="rbt-rbt-blog-area rbt-section-gapTop bg-gradient-8 rbt-round-bottom-shape">
        <div className="wrapper pb--50 rbt-index-upper">
          <div className="container">
            <div className="row g-5 align-items-end mb--60">
              <div className="col-lg-6 col-md-12 col-12">
                <div className="section-title text-start">
                  <h2 className="title color-white">{t("onSmartTech.latestNews.title", "Latest News")}</h2>
                  <p className="description color-white-off mt--20">
                    {t("onSmartTech.latestNews.description", "Free, structured courses built around real projects — learn skills that translate directly into a tech career.")}
                  </p>
                </div>
              </div>
              <div className="col-lg-6 col-md-12 col-12">
                <div className="load-more-btn text-start text-lg-end">
                  <a className="rbt-btn btn-border icon-hover radius-round color-white-off" href={ROUTE.blog}>
                    <span className="btn-text">{t("onSmartTech.latestNews.seeAll", "See All Articles")}</span>
                    <span className="btn-icon"><i className="feather-arrow-right"></i></span>
                  </a>
                </div>
              </div>
            </div>

            <BlogGridMinimal />
          </div>
        </div>
      </div>

      <div className="rbt-newsletter-area bg-color-white rbt-section-gapBottom pt--60">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <Newsletter_2 />
            </div>
          </div>
        </div>
      </div>

    </>
  );
};

export default EventsOnSmartTech;
